import React from 'react';

const Footer = () => {
  return (
   <>
   <section className="footer pt-5 pb-4 pb-lg-5">
   <div className="container">
        <div className="media-container-row align-center">
            <div className="col-12">
                <p className="mbr-text mbr-regular mb-0">
                    © Copyright 2025 Soft Cygnus – All Rights Reserved
                </p>
            </div>
        </div>
    </div>
   </section>
   </>
  )
}

export default Footer